import { useEffect } from 'react';

import { useIntl } from '@leagueplatform/locales';
import { APP_MANAGED_ROUTES } from 'common/constants';
import { CompletionPage } from 'components/completion-page/completion-page.component';
import { sendPaymentCompletedScreenLoadedEvent } from 'utils/analytics-events';

const PaymentCompleted = () => {
  const { formatMessage } = useIntl();

  useEffect(() => {
    sendPaymentCompletedScreenLoadedEvent();
  }, []);

  return (
    <CompletionPage
      nextPath={APP_MANAGED_ROUTES.SUPPLEMENTAL_PREMIUM_PAYMENT}
      title={formatMessage({ id: 'STR_SETUP_COMPLETE' })}
      description={formatMessage({
        id: 'STR_AUTOMATIC_PAYMENT_COMPLETED_DESCRIPTION',
      })}
      continueButtonText={formatMessage({ id: 'STR_DONE' })}
    />
  );
};

export default PaymentCompleted;
